import { createRoute } from '@tanstack/react-router'

import { appRoute } from '@/app'

import { Invitation } from './Invitation'

export const invitationRoute = createRoute({
    getParentRoute: () => appRoute,
    path: '/invitation',
    component: Invitation,
})
